import {useSelector} from 'react-redux'
import {useOtaMode} from 'hooks/useOtaMode'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {selectIsAuthenticated} from '@vio/core/src/auth/modules/selectors'

/**
 * Whether this user should be offered the pre-checkout sign-in step, either the
 * optional one with a "Continue as guest" escape hatch or the mandatory gate.
 * The optional step stays out of OTA mode, which runs its own funnel. The gate
 * applies there too.
 */
export const useIsOptionalSignInEligible = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const {auth} = useBrandCapabilities()
  const {isOTAMode} = useOtaMode()

  return (
    !isAuthenticated &&
    (auth.requiresSignInForCheckout ||
      (auth.showSignInToComplete && !isOTAMode))
  )
}
